export function isIndexWidget(widget) {
  return widget.$$type === 'ais.index';
}